export default __webpack_public_path__ + "static/media/kuas.db90125a.png";